<template>
  <v-card>
    <v-tabs :value="interCommDiscFactTab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchInterCommDiscFactors()">Factors</v-tab>
      <v-tab v-show="displayFactReviewTab">Rates</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU } from '@/store/types'

export default {
  computed: {
    interCommDiscFactTab() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorTabMenu
    },
    displayFactReviewTab() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorDisplayFactReviewTab
    }
  },
  methods: {
    fetchInterCommDiscFactors() {
      const commitData = {
        interCommDiscFactTab: 0,
        displayFactReviewTab: false,
        displayRateTab: false
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      this.$router.push({ name: 'interCommDiscFactorsQuery', params: { inter: this.inter } })
    }
  },
  props: {
    inter: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchInterCommDiscFactors()
  }
}
</script>

<style lang="scss">
</style>
